import React from 'react';
import './App.css'; // Assuming your CSS file

const CoverImageSecond = () => {
    return (
        <div className="cover-image-background">
            <div className="image1-text reveal">
                <h1>Our Excellent Service</h1>
                <p>
                    At our company, we pride ourselves on delivering top-notch services
                    that cater to your needs. Whether you're looking for expert advice,
                    professional care, or cutting-edge solutions, we are here to serve you.
                </p>
            </div>
        </div>
    );
};

export default CoverImageSecond;
